export function parseNewLines(text: string) {
    if (text) {
        return text.replace(/##/g, '\n');
    }
    return '';
}
